import { axiosInstance } from "../../utils";

const actions = {
    FETCH_RATINGS_REQUESTED: 'FETCH_RATINGS_REQUESTED',
    FETCH_RATINGS_SUCCEEDED: 'FETCH_RATINGS_SUCCEEDED',
    FETCH_RATINGS_FAILED: 'FETCH_RATINGS_FAILED',

    DELETE_RATE_REQUESTED: 'DELETE_RATE_REQUESTED',
    DELETE_RATE_SUCCEEDED: 'DELETE_RATE_SUCCEEDED',
    DELETE_RATE_FAILED: 'DELETE_RATE_FAILED',

    fetchRatings: (params = undefined) => {
        return {
            type: actions.FETCH_RATINGS_REQUESTED,
            payload: params
        }
    },

    removeRate: (params = undefined) => {
        return {
            type: actions.DELETE_RATE_REQUESTED,
            payload: params
        }
    },

    getRatings: async (params = undefined) => {
        const url = `ratings`;

        try {
            const ratings = await axiosInstance.get(url,{ params });
            return ratings.data;
        } catch (error) {
            throw error;
        }
    },

    deleteRate: async (params = undefined) => {
        let rateType = params.rating_type;
        if(rateType == "products") rateType = "items";
        const url = `ratings/` + rateType + '/' + params._id;

        try {
            const ratings = await axiosInstance.delete(url);
            return ratings.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
